import { Descriptions } from 'antd';
import type { WorkOrderDetailsView } from '@chukua/common';
import { WORKSHOP_LABELS } from '../policies/workshop-form.policy';

function orDash(value: string | null): string {
  return value ?? '—';
}

/** The current workshop details, or a line saying none are recorded yet. */
export function WorkshopDescriptions({ details }: { details: WorkOrderDetailsView | null }) {
  if (details === null) return <p className="m-0 text-muted">No workshop chosen yet.</p>;
  return (
    <Descriptions column={{ xs: 1, md: 2 }} size="small" bordered>
      <Descriptions.Item label="Where">{WORKSHOP_LABELS[details.workshop]}</Descriptions.Item>
      <Descriptions.Item label="Garage">{orDash(details.garageName)}</Descriptions.Item>
      <Descriptions.Item label="Odometer">{orDash(details.odometerKm === null ? null : `${details.odometerKm.toLocaleString('en-KE')} km`)}</Descriptions.Item>
      <Descriptions.Item label="Warranty">{orDash(details.warrantyMonths === null ? null : `${details.warrantyMonths} months`)}</Descriptions.Item>
      <Descriptions.Item label="Symptoms" span="filled">
        {orDash(details.symptoms)}
      </Descriptions.Item>
      <Descriptions.Item label="Diagnosis" span="filled">
        {orDash(details.diagnosis)}
      </Descriptions.Item>
    </Descriptions>
  );
}
